import { DPProduct } from './dp-product';
import { DPModuleConfig } from './dp-module-config';

export class DPModule {
    account_id: number;
    subscription_id: number;
    product: DPProduct;
    product_id: number;
    configs: DPModuleConfig[];

    constructor() {
        this.product;
        this.configs = new Array<DPModuleConfig>();
    }
}




// WEBPACK FOOTER //
// ./src/app/portalv1/model/dp-module.ts